import { Roles } from "_enums/enums";

/**
 * Whether a user object represents a fully usable, dashboard-ready session.
 *
 * The backend only issues a real session token (isLoggedIn) to users who are
 * allowed in, but the "profile complete" concept differs by role:
 *  - Landlord / TradesPerson finish signup by completing their profile, so
 *    isProfileComplete is the gate (a partial signup carries only a scoped
 *    profile-completion token, never a real session).
 *  - Tenant has no such profile-completion step: login()/create() (service/user.js)
 *    hand an email-verified Tenant a real jwtToken while leaving isProfileComplete
 *    at its schema default of false. So for Tenants a live session IS complete —
 *    gating them on isProfileComplete strands them on the login screen.
 */
export const isSessionComplete = (user) =>
  Boolean(
    user?.isLoggedIn &&
      (user?.isProfileComplete || user?.role === Roles.Tenant),
  );
